import "../../styles/settings/manageSubscription.css";
import { BsArrowBarLeft, BsCalendarDate, BsCheck } from "react-icons/bs";
import { subscriptionURL, cancelSubscriptionURL, freeSubscriptionUrl } from "../../api/endpoints";
import { useState, useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../slice/webStoreUserSlice";
import { useNavigate } from "react-router-dom";
import coinImage from "../../assetsStatic/coin.png";
import { FaAngleRight } from "react-icons/fa";
import PaystackPop from "@paystack/inline-js";
import { io } from "socket.io-client";
import Spinner from "../../components/uxCollections/Loaders";
import DeliverToggle, { SubscriptionToggle } from "../../components/toggleButton/DeliverToggle";
import TrialShowcase from "./FreeTrail";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

/* const subscriptionPlanCodes=[
  {
    plan: "Basic",
    planCodeMonthly: "PLN_lbro2p90abucr1i",
    planCodeHalfYearly: "PLN_7j4uikc9xu8noq2",
  },
  {
    plan:"Super",
    planCodeMonthly: "PLN_gz3p2q94b9r0apg",
    planCodeHalfYearly: "PLN_f1eh57906yzkibz",
  },
  {
    plan:"Premium",
    planCodeMonthly: "PLN_o0yjesxw73ffcvr",
    planCodeHalfYearly: "PLN_e4eaehblco2v3dv",
  }
] */
const subscriptionPlanCodes = {
  monthly: [
    {
      plan: "Basic",
      planCode: "PLN_hahlu4ksdvaf2z7",
    },
    {
      plan: "Super",
      planCode: "PLN_zivia4d7pckqvsk",
    },
    {
      plan: "Premium",
      planCode: "PLN_ju6xfjdjmvl0qoy",
    },
  ],

  halfYearly: [
    {
      plan: "Basic",
      planCode: "PLN_ji48utkusa78t84",
    },
    {
      plan: "Super",
      planCode: "PLN_mz8paaufypmh9mo",
    },
    {
      plan: "Premium",
      planCode: "PLN_kik3nlu0ani881s",
    },
  ],
};

const SubCard = ({ name, price, discountPrice, currency, includes, popular, setIsLoading, socket, planCode, subscriptionRange }) => {
  const { user } = useSelector((state) => state.webStoreUser);
  console.log("subscription plan code", price, planCode);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const popup = new PaystackPop();

  const handleSubSelection = async (selected) => {
    uiAlert("You are about to subscribe to " + name + " plan for " + discountPrice.toLocaleString() + " " + subscriptionRange + ". Click ok to continue");
    let accessToken = localStorage.getItem("accessToken");
    console.log(selected);

    try {
      let response = await fetch(subscriptionURL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(selected),
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        socket.emit("paymentCreated", user._id);
        let { accessCode } = await response.json();
        popup.resumeTransaction(accessCode, {
          onCancel: function () {
            setIsLoading(false);
          },
        });
        setIsLoading(true);
        // dispatch(setUser(data));
        // console.log("subscription updated", data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      //  setIsLoading(false);
    }
  };

  return (
    <div onClick={() => handleSubSelection({ userType: name, price, subscriptionRange, plan_code: planCode })}>
      <div className='subscriptionCard'>
        <p>Saver</p>
        <div style={{ backgroundColor: ` ${name === "Basic" ? "black" : name === "Super" ? "#0e49b5" : "rgb(82, 9, 124)"} ` }}> {name}</div>
        <div>
          <span className='currencySubCard'> {currency} </span>
          <span className='realPrice863'>
            {currency} {price.toLocaleString()}{" "}
          </span>
          <p>{discountPrice.toLocaleString()}</p>
        </div>
        <p style={{ fontWeight: "bold" }}>{subscriptionRange === "monthly" ? "Monthly" : "6 months"}</p>
        <p>For {name?.toLowerCase()} users and it includes:</p>
        <div className='packageIncludes'>
          {includes?.map((item, index) => (
            <div key={index}>
              <BsCheck color='green' />
              <p>{item}</p>
            </div>
          ))}
          {/*   
                <div>
                  <BsCheck color="green" />
                  <p>Create one store</p>
                </div>
                <div>
                  <BsCheck color="green" />
                  <p>24/7 support</p>
                </div>
                <div>
                  <BsCheck color="green" />
                  <p>E-commerce</p>
                </div>
                <div>
                  <BsCheck color="green" />
                  <p>Access to Ihub platform</p>
                </div> */}
        </div>
        <button className='chooseplanButton'>Choose plan</button>
        {popular && <p className='recommenedPack'>popular</p>}
      </div>
    </div>
  );
};

const ManageSubscription = () => {
  const socket = useMemo(() => io(process.env.REACT_APP_Back_end_api_root, { transports: ["websocket"] }), []);
  const [openOnlineVendorModal, setOpenOnlineVendorModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [subscriptionRange, setSubscriptionRange] = useState("monthly");
  const { user } = useSelector((state) => state.webStoreUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    console.log(isLoading);
  }, [isLoading]);

  useEffect(() => {
    // connect to socket and create room with user._id
    socket.on("connect", () => {
      console.log(socket.id); // x8WIv7-mJelg7on_ALbx
      socket.emit("createRoom", user._id);
    });

    socket.on("userSuscribed", (user) => {
      if (user._id.toString() === user._id.toString()) {
        uiAlert("user subscribed", "success");
        dispatch(setUser(user));
        setIsLoading(false);
      }
      console.log("user subscribed", user);
    });
    socket.on("userUnsubscribed", (user) => {
      if (user._id.toString() === user._id.toString()) {
        dispatch(setUser(user));
        /*  setIsLoading(false); */
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const handleCancelSubscription = async () => {
    let accessToken = localStorage.getItem("accessToken");

    try {
      let response = await fetch(cancelSubscriptionURL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        let data = await response.json();
        dispatch(setUser(data));
        console.log("subscription updated", data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const startFreeTrial = async () => {
    let accessToken = localStorage.getItem("accessToken");
    setIsLoading(true);
    try {
      let response = await fetch(freeSubscriptionUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ userType: "Free", price: "0", subscriptionRange: "monthly", plan_code: "free" }),
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        let user = await response.json();
        dispatch(setUser(user));
        uiAlert("You have started a free trial for 7 days", "success");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!user.userIsSubscribed ? (
        <div className='mSubscriptionWrapper'>
          <h3 className='privacy-data-info-title cp-title' style={{ fontWeight: "900" }}>
            Choose your plan
          </h3>
          <p>You need to choose a subscription plan to create stores, warehouse and Manage your inventory. You can always cancel at anytime</p>
          <div className='subSwitch283'>
            <span
              style={
                subscriptionRange === "monthly"
                  ? {
                      color: "rgb(86, 137, 55)",
                      fontWeight: "bold",
                      fontSize: "1rem",
                    }
                  : {}
              }
            >
              Monthly
            </span>
            <SubscriptionToggle toggleValue={subscriptionRange} updatetoggle={setSubscriptionRange} />
            <span
              style={
                subscriptionRange === "halfYearly"
                  ? {
                      color: "rgb(106 157 207)",
                      fontWeight: "bold",
                      fontSize: "1rem",
                    }
                  : {}
              }
            >
              Half yearly
            </span>
          </div>
          <div onClick={() => setOpenOnlineVendorModal(true)} className='onlineVendor87363'>
            <p>Online vendors only plan</p>
            <FaAngleRight color='rgb(14, 73, 181' />
          </div>
          <div className='subPlanWrapper'>
            <SubCard
              name={"Basic"}
              price={subscriptionRange === "monthly" ? 8000 : 40000}
              discountPrice={subscriptionRange === "monthly" ? 4000 : 20000}
              currency={user.userCountryCurrencySymbol}
              includes={[
                "Create one store",
                "Business KPI tracking",
                "List only 60 products",
                "Free support",
                "Access our E-Commerce Hub",
                "Free hardware installation",
                "2% discount on extra services",
              ]} // "Access to Ihub platform"
              setIsLoading={setIsLoading}
              socket={socket}
              planCode={subscriptionRange === "monthly" ? subscriptionPlanCodes.monthly[0].planCode : subscriptionPlanCodes.halfYearly[0].planCode}
              subscriptionRange={subscriptionRange}
            />
            <SubCard
              name={"Super"}
              price={subscriptionRange === "monthly" ? 17000 : 90000}
              discountPrice={subscriptionRange === "monthly" ? 8500 : 45000}
              currency={user.userCountryCurrencySymbol}
              includes={[
                "Basic user Ad ons",
                "Create two stores",
                "Create one warehouse",
                "24 hours free Ad monthly",
                "List upto 200 products",
                "Free hardware installation",
                "10% discount on extra services",
                "Free personel training",
              ]}
              popular={true}
              setIsLoading={setIsLoading}
              socket={socket}
              planCode={subscriptionRange === "monthly" ? subscriptionPlanCodes.monthly[1].planCode : subscriptionPlanCodes.halfYearly[1].planCode}
              subscriptionRange={subscriptionRange}
            />
            <SubCard
              name={"Premium"}
              price={subscriptionRange === "monthly" ? 42500 : 205000}
              discountPrice={subscriptionRange === "monthly" ? 21250 : 102500}
              currency={user.userCountryCurrencySymbol}
              includes={[
                "Super user Ad ons",
                "Create upto 5 stores",
                "Create 3 warehouses",
                "50 hours free Ad monthly",
                "List up 700 products",
                "Free hardware installation",
                "30% discount on extra services",
                "Free personel training",
              ]}
              setIsLoading={setIsLoading}
              socket={socket}
              planCode={subscriptionRange === "monthly" ? subscriptionPlanCodes.monthly[2].planCode : subscriptionPlanCodes.halfYearly[2].planCode}
              subscriptionRange={subscriptionRange}
            />
          </div>
          {user.freePlanUsed ? (
            <p>
              Do you need an <span style={{ color: "rgb(165, 126, 17)", fontWeight: "bolder" }}>Enterprice package</span>?{" "}
              {/* you can start a <span style={{ color: "#b6a843", cursor: "pointer", fontWeight: "bold" }}>free 2 days Trial </span> */}{" "}
              <span style={{ color: "rgb(9, 76, 126)", cursor: "pointer", fontWeight: "bold" }}>Contact support </span>
              <span>for a customized experience</span>
            </p>
          ) : (
            <p>
              Not sure which to choose,{" "}
              <span onClick={startFreeTrial} style={{ color: "rgb(165, 126, 17)", fontWeight: "800", textDecoration: "underline", cursor: "pointer" }}>
                Start a 7 days free trial.
              </span>
              ? {/* you can start a <span style={{ color: "#b6a843", cursor: "pointer", fontWeight: "bold" }}>free 2 days Trial </span> */}{" "}
              <span>For a customized experience </span>
              <span style={{ color: "rgb(9, 76, 126)", cursor: "pointer", fontWeight: "bold", textDecoration: "underline" }}>Contact support </span>
            </p>
          )}
          {isLoading && <Spinner position={"fixed"} backgroundColor='rgba(240, 240, 240, 0.46)' />}
        </div>
      ) : user.freeTrial ? (
        <>
          <TrialShowcase setIsLoading={setIsLoading} socket={socket} />
          {isLoading && <Spinner position={"fixed"} backgroundColor='rgba(240, 240, 240, 0.46)' />}
        </>
      ) : (
        <>
          <div className='userIsSubscribedDIv'>
            <h3 className='privacy-data-info-title cp-title' style={{ fontWeight: "800", marginBottom: "30px", padding: "20px 0" }}>
              Update subscription plan
            </h3>

            <UpdateSubscription user={user} socket={socket} setIsLoading={setIsLoading} />
            <div className='subInfo352'>
              <div>
                For a more customized experience, you can{" "}
                <a style={{ color: "rgb(14, 145, 181)", margin: "0 4px" }} href='#'>
                  Contact support
                </a>{" "}
                for an enterprise package
              </div>
            </div>
            <button onClick={handleCancelSubscription} className='cancelSubButton'>
              Cancel subscription
            </button>
            {user.userType.userType === "Online vendors plan" && (
              <span className='onlineVTag'>
                <span></span>
                {user.userType.userType}
              </span>
            )}
          </div>
          {isLoading && <Spinner position={"fixed"} backgroundColor='rgba(240, 240, 240, 0.46)' />}
        </>
      )}
      {openOnlineVendorModal && <OnlineVendor setOpenOnlineVendorModal={setOpenOnlineVendorModal} />}
    </>
  );
};

export default ManageSubscription;

const OnlineVendor = ({ setOpenOnlineVendorModal }) => {
  return (
    <>
      <div onClick={() => setOpenOnlineVendorModal(false)} className='onlineVendorWrapper'>
        <div onClick={(e) => e.stopPropagation()} className='vendorCont3763'>
          <div className='headerMonk23'>
            <p>Online Vendor package</p>
          </div>
          <div className='vCardue664'>
            <div>
              <h4>No physical store</h4>
              <div className='njshd7d7'>
                <p className='njsufbshd7d7'>
                  This plan is for online vendors only. <br /> It includes all the features of the supper user plan
                </p>
              </div>
            </div>
            <div>
              <h4>List up 50 products</h4>
              <div className='njshd7d7'>
                <p className='njsufbshd7d7'> Manage up to fifty products in your online store. Perfect for growing businesses with large catalogs..</p>
              </div>
            </div>
            <div>
              <h4>Real time analytics</h4>
              <div className='njshd7d7'>
                <p className='njsufbshd7d7'>
                  Monitor store performance with live insights. <br /> See customer activity and product trends instantly.
                </p>
              </div>
            </div>
          </div>

          <div className='bottomDiv8hjbd'>
            <button>Buy now ₦10,000 for 6 months</button>
            <button onClick={() => setOpenOnlineVendorModal(false)}>
              {" "}
              <BsArrowBarLeft /> Choose another
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

const UpdateSubscription = ({ user, socket, setIsLoading }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const popup = new PaystackPop();

  useEffect(() => {
    // listen to socket event for payment created
    socket.on("userSuscribed", (user) => {
      if (user._id === user._id) {
        uiAlert("user subscribed", "success");
        dispatch(setUser(user));
        setIsLoading(false);
      }
      console.log("user subscribed", user);
    });
  }, []);

  const handleSubSelection = async (selected) => {
    let accessToken = localStorage.getItem("accessToken");
    console.log(selected);

    try {
      let response = await fetch(subscriptionURL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(selected),
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        socket.emit("paymentCreated", user._id);
        let { accessCode } = await response.json();
        popup.resumeTransaction(accessCode);
        setIsLoading(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className='updSub36453'>
        <div
          style={
            user.userType.userType.includes("Basic")
              ? {
                  scale: "1.05",
                  transition: "all 1s ease-in-out",
                  boxShadow: "0px 0px 30px 0 rgb(225, 236, 255) ",
                  border: "1px solid rgb(76, 136, 247) ",
                }
              : {}
          }
        >
          <div className='subCardHeader8d'>
            <span>Basic plan</span>
            <p>
              {" "}
              <span></span> Saver
            </p>
          </div>
          <p className='subCardPriceWrp399'>
            <b className='subCardPrice0999'>₦40,000 </b>/six months
          </p>
          {user.userType?.userType?.includes("Basic") ? (
            <div>
              <BsCalendarDate color='rgb(14, 73, 181)' />
              <p>
                {" "}
                {user.userType?.renewDate ? "Renews" : "Ends"} {new Date(user.userType?.subcriptionEndDate).toDateString()}
              </p>
            </div>
          ) : (
            ""
          )}
          {user.userType.userType.includes("Basic") ? (
            <div style={{ backgroundColor: "rgb(255, 225, 103)" }} className='cardbtnDivd'>
              Current plan
            </div>
          ) : (
            <div
              onClick={() =>
                handleSubSelection({
                  userType: "Basic",
                  price: "50000",
                  subscriptionRange: "halfYear",
                  plan_code: subscriptionPlanCodes.halfYearly[0].planCode,
                })
              }
              className='cardbtnDivd'
            >
              Choose
            </div>
          )}
          <div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Create one store</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Business KPI tracking</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span> List only 60 products</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Free support</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Access to E-commerce Hub</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Free hardware installation</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>2% discount on extra services</span>
            </div>
          </div>
        </div>
        <div
          style={
            user.userType.userType.includes("Super")
              ? {
                  scale: "1.05",
                  transition: "all 1s ease-in-out",
                  boxShadow: "0px 0px 30px 0 rgb(161, 159, 159) ",
                  color: "white",
                  backgroundColor: "rgb(6, 6, 6)",
                  border: "2px solid rgb(252, 232, 44) ",
                }
              : { color: "white", backgroundColor: "rgb(6, 6, 6)" }
          }
        >
          <div className='subCardHeader8d'>
            <span style={{ color: "white" }}>Super plan</span>
            <p style={{ backgroundColor: "#FCE82C", color: "rgb(107, 103, 21)", boxShadow: "none" }}>
              {" "}
              <span style={{ backgroundColor: "rgb(79, 75, 7)" }}></span> Popular
            </p>
          </div>
          <p className='subCardPriceWrp399'>
            <b className='subCardPrice0999'>₦90,000</b> /six months
          </p>
          {user.userType.userType?.includes("Super") ? (
            <div>
              <BsCalendarDate color='rgb(255, 255, 255)' />
              <p>
                {" "}
                {user.userType.renewDate ? "Renews" : "Ends"} {new Date(user.userType?.subcriptionEndDate).toDateString()}
              </p>
            </div>
          ) : (
            ""
          )}
          {user.userType.userType?.includes("Super") ? (
            <div style={{ backgroundColor: "rgb(238, 238, 29)", color: "black" }} className='cardbtnDivd'>
              Current plan
            </div>
          ) : (
            <div
              onClick={() =>
                handleSubSelection({
                  userType: "Super",
                  price: "50000",
                  subscriptionRange: "halfYear",
                  plan_code: subscriptionPlanCodes.halfYearly[1].planCode,
                })
              }
              style={{ backgroundColor: "white", color: "black", fontWeight: "700" }}
              className='cardbtnDivd'
            >
              Upgrade
            </div>
          )}
          <div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Basic user Ad ons</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Create two stores</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Create one warehouse</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>24 hours free Ad monthly</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>List upto 200 products</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Free hardware installation</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>10% discount on extra services</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Free personel training</span>
            </div>
          </div>
        </div>

        <div
          style={
            user.userType.userType.includes("Premium")
              ? {
                  scale: "1.05",
                  transition: "all 1s ease-in-out",
                  boxShadow: "0px 0px 30px 0 rgb(225, 236, 255) ",
                  border: "1px solid rgb(76, 136, 247) ",
                }
              : {}
          }
        >
          <div className='subCardHeader8d'>
            <span>Premium plan</span>
            <p>
              {" "}
              <span></span> Saver
            </p>
          </div>
          <p className='subCardPriceWrp399'>
            <b className='subCardPrice0999'>₦205,000 </b>/six months
          </p>
          {user.userType.userType?.includes("Premium") ? (
            <div>
              <BsCalendarDate color='rgb(14, 73, 181)' />
              <p>
                {user.userType.renewDate ? "Renews" : "Ends"} {new Date(user.userType.subcriptionEndDate).toDateString()}
              </p>
            </div>
          ) : (
            ""
          )}
          {user.userType.userType.includes("Premium") ? (
            <div style={{ backgroundColor: "rgb(255, 225, 103)" }} className='cardbtnDivd'>
              Current plan
            </div>
          ) : (
            <div
              onClick={() =>
                handleSubSelection({
                  userType: "Premium",
                  price: "50000",
                  subscriptionRange: "halfYear",
                  plan_code: subscriptionPlanCodes.halfYearly[2].planCode,
                })
              }
              style={{ fontWeight: "700", backgroundColor: "#0e49b5", color: "white" }}
              className='cardbtnDivd'
            >
              Upgrade
            </div>
          )}
          <div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Super user Ad ons</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Create upto Five stores</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Create 3 warehouses</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>50hrs free Ad monthly</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>List upto 700 products</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Free hardware installation</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>30% discount on extra services</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Free personel training</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
